import Navbar from "./Navbar";
import Footer from "./Footer";

const MainLayout = ({ children, color }) => {
	return (
		<main>
			<Navbar colorBg={color} />
			{children}
			<Footer />
		</main>
	);
};

export default MainLayout;
